import {
  Button,
  CardContent,
  Grid,
  Typography,
  Box,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import MyTable, { TableRow } from "../../../components/MyTable";
import { TableHeadRows } from "../../../components/MyTable/TableHead";
import MySnackbar from "../../../components/MySnackbar";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { getDatestring } from "../../../utils/date";
import { signedDownloadUrl } from "../../../api/fileStorage";

export interface Attendance {
  AttendaceMarkId: number;
  EmployeeId: number;
  DeviceName: string;
//   FullName: string;
  Code: string;
  DocumentNumber: string;
  DateTimeShift: string;
  DateTimeWorkShift: string;
  DateTimeMark: string;
  AuthenticationType: string;
  MarkType: string;
  IPAddress: string;
  Longitude: number | null;
  Latitude: number | null;
  CompanyCode: string;
  CompanyDescription: string;
  ProjectDescription: string;
  EmployeeRegimeDescription: string;
  PhotoKey: string;
}

interface TableAttendancesProps {
    attendances: Attendance[];
    loading: boolean;
    setStartDate: (value: Date | null) => void;
    startDate: Date | null;
    setEndDate: (value: Date | null) => void;
    endDate: Date | null;
}

const TableAttendances = ({
    attendances, 
    loading ,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: TableAttendancesProps) => {
//   const [attendances, setAttendances] = useState<Attendance[]>([]);
  const [filteredAttendances, setFilteredAttendances] = useState<Attendance[]>([]);
//   const [loading, setLoading] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState<any>();
  const [markTypeFilter, setMarkTypeFilter] = useState<string>("all");
  const [searchValue, setSearchValue] = useState("");
//   const [internalStartDate, setInternalStartDate] = useState<Date | null>(startDate || null);
//   const [internalEndDate, setInternalEndDate] = useState<Date | null>(endDate || null);
  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState<Attendance | null>(null);
  const [imageUrl, setImageUrl] = useState("");
  const [imageLoading, setImageLoading] = useState(false);

    const attendanceHeader: TableHeadRows[] = [
        {
            label: "Fecha",
            rowKeyName: "DateTimeWorkShift",
            customValue: (_, row: TableRow<string, any>) =>
                getDatestring(row.DateTimeWorkShift, "-", false),
        },
        { label: "Hora", rowKeyName: "DateTimeMark" },
        {
            label: "Tipo",
            rowKeyName: "MarkType",
            customValue: (_, row: TableRow<string, any>) => {
                const isEntrance = row.MarkType.toLowerCase().includes("entrada");
                return (
                <span
                    style={{
                    color: isEntrance ? "#4caf50" : "#f44336",
                    fontWeight: "bold",
                    }}
                >
                    {row.MarkType}
                </span>
                );
            },
        },
        { label: "IP", rowKeyName: "IPAddress" },
        { label: "Dispositivo", rowKeyName: "DeviceName" },
        {
            label: "Ubicación",
            rowKeyName: "googleMapUrl",
            customValue: (_, row: TableRow<string, any>) => {
                if (!row.Latitude || !row.Longitude) return "No disponible";
                return (
                <Button
                    variant="outlined"
                    size="small"
                    startIcon={<LocationOnIcon />}
                    onClick={() => handleViewLocation(row as Attendance)}
                >
                    Ver
                </Button>
                );
            },
        },
    ];

    const applyFilters = (data: Attendance[], search: string, mark: string) => {
        let filtered = data;
        // if (search) {
        //     filtered = filtered.filter((a) =>
        //         a.FullName.toLowerCase().includes(search.toLowerCase())
        //     );
        // }
        if (mark !== "all") {
            filtered = filtered.filter((a) => a.MarkType === mark);
        }
        setFilteredAttendances(filtered);
    };

    useEffect(() => {
        applyFilters(attendances, searchValue, markTypeFilter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attendances, searchValue, markTypeFilter]);


    const handleViewLocation = (attendance: Attendance) => {
        setSelectedAttendance(attendance);
        setLocationModalOpen(true);
    };

    const openGoogleMaps = () => {
        if (selectedAttendance?.Latitude && selectedAttendance?.Longitude) {
            window.open(
                `https://www.google.com/maps?q=${selectedAttendance.Latitude},${selectedAttendance.Longitude}&z=17`,
                "_blank"
            );
        }
    };

    const handleViewPhoto = async (attendance: Attendance) => {
        if (!attendance.PhotoKey || imageLoading) return;
        setImageLoading(true);
        const ruc = attendance.PhotoKey.split('/')[0];
        const result = await signedDownloadUrl(ruc, [{ Key: attendance.PhotoKey }]);
        if (result?.Type === 0 && result.Value?.length && result.Value[0].Presigned_url) {
            setImageUrl(result.Value[0].Presigned_url);
        } else {
            setSnackBarMessage({
                success: false,
                msg: result?.Message || "Error al cargar la imagen",
            });
        }
        setImageLoading(false);
    };

    const renderCard = (row: Attendance) => {
        const isEntrance = row.MarkType.toLowerCase().includes("entrada");
        return (
            <CardContent style={{ padding: "1rem" }}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Fecha:</strong> {getDatestring(row.DateTimeWorkShift.split('T')[0], "-", false)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Hora:</strong> {row.DateTimeMark}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Tipo:</strong>{" "}
                        <span style={{ color: isEntrance ? "#4caf50" : "#f44336", fontWeight: "bold" }}>
                            {row.MarkType}
                        </span>
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Dispositivo:</strong> {row.DeviceName}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>IP:</strong> {row.IPAddress || "N/A"}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Empresa:</strong> {row.CompanyDescription}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Proyecto:</strong> {row.ProjectDescription}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2">
                        <strong>Régimen:</strong> {row.EmployeeRegimeDescription}
                        </Typography>
                    </Grid>
                    {row.Latitude && row.Longitude && (
                        <Grid item xs={6}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<LocationOnIcon />}
                            onClick={() => handleViewLocation(row)}
                        >
                            Ubicación
                        </Button>
                        </Grid>
                    )}
                    {row.PhotoKey && (
                        <Grid item xs={6}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleViewPhoto(row)}
                            disabled={imageLoading}
                        >
                            {imageLoading ? "Cargando..." : "Foto"}
                        </Button>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        );
    };

    return (
        <>
            <MyTable
                tableHeadRows={attendanceHeader}
                tableRows={filteredAttendances}
                loading={loading}
                searchInputString={searchValue}
                onChangeSearchInputString={setSearchValue}
                rangeControlProps={{
                startDate: startDate,
                endDate: endDate,
                setStartDate: setStartDate,
                setEndDate: setEndDate,
                }}
                customItemOptionBarMiddle={() => (
                    <Grid item>
                        <FormControl style={{ minWidth: 120 }}>
                        <InputLabel id="mark-type-label">Tipo</InputLabel>
                        <Select
                            labelId="mark-type-label"
                            value={markTypeFilter}
                            label="Tipo"
                            onChange={(e) => setMarkTypeFilter(e.target.value)}
                            size="small"
                        >
                            <MenuItem value="all">Todos</MenuItem>
                            <MenuItem value="Entrada">Entrada</MenuItem>
                            <MenuItem value="Salida">Salida</MenuItem>
                        </Select>
                        </FormControl>
                    </Grid>
                )}
                cardComponent={{
                    cardContent: (row) => renderCard(row as Attendance),
                    numberOfCards: 1,
                }}
                tableOptionsBar={{ useDrawer: true }}
            />

            <Modal open={locationModalOpen} onClose={() => setLocationModalOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: 800,
                        height: "80%",
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        overflow: "hidden",
                    }}
                >
                {selectedAttendance && (
                    <>
                        <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider" }}>
                            <Typography variant="h6">Ubicación de marcación</Typography>
                            <Typography variant="body2" color="text.secondary">
                            {selectedAttendance.DateTimeWorkShift} {selectedAttendance.DateTimeMark}
                            </Typography>
                        </Box>
                        <Box sx={{ width: "100%", height: "calc(100% - 130px)" }}>
                            <iframe
                            title="map"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${
                                selectedAttendance.Longitude! - 0.01
                            },${selectedAttendance.Latitude! - 0.01},${
                                selectedAttendance.Longitude! + 0.01
                            },${selectedAttendance.Latitude! + 0.01}&layer=mapnik&marker=${
                                selectedAttendance.Latitude
                            },${selectedAttendance.Longitude}`}
                            allowFullScreen
                            />
                        </Box>
                        <Box sx={{ p: 2, textAlign: "center", borderTop: 1, borderColor: "divider" }}>
                            <Button variant="outlined" onClick={openGoogleMaps} sx={{ mr: 2 }}>
                            Google Maps
                            </Button>
                            <Button variant="contained" onClick={() => setLocationModalOpen(false)}>
                            Cerrar
                            </Button>
                        </Box>
                    </>
                )}
                </Box>
            </Modal>

            <Modal open={!!imageUrl} onClose={() => setImageUrl("")}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        maxWidth: "90%",
                        maxHeight: "90%",
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        overflow: "hidden",
                    }}
                >
                <Box sx={{ p: 2, textAlign: "center" }}>
                    <img
                    src={imageUrl}
                    alt="Foto de asistencia"
                    style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
                    />
                </Box>
                <Box sx={{ p: 2, textAlign: "center", borderTop: 1, borderColor: "divider" }}>
                    <Button variant="contained" onClick={() => setImageUrl("")}>
                    Cerrar
                    </Button>
                </Box>
                </Box>
            </Modal>

            <MySnackbar
                open={!!snackBarMessage}
                msg={snackBarMessage?.msg || ""}
                severity={snackBarMessage?.success ? "success" : "error"}
                onClose={() => setSnackBarMessage(undefined)}
            />
        </>
    );
};

export default TableAttendances;